module.exports = __webpack_public_path__ + "static/media/shopify.d200f665.png";